import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum K1893InvoiceLineItemKeys {
  itemNumber = 'itemNumber',
  description = 'description',
  externalItemNumber = 'externalItemNumber',
  eaUPC = 'eaUPC',
  caseQtyOrdered = 'caseQtyOrdered',
  caseCost = 'caseCost',
  discountRate = 'discountRate',
  discountPrice = 'discountPrice',
  lineTotal = 'lineTotal',
}

export const k1893InvoiceFileDataSchema = yup.object({
  issuer: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  recipient: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  invoiceNumber: yup.string().nullable().optional(),
  associatedReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  remittanceInstructions: yup
    .object({
      routingNumber: yup.string().nullable().optional(),
      accountNumber: yup.string().nullable().optional(),
      bankName: yup.string().nullable().optional(),
      bankAddress: yup.string().nullable().optional(),
      beneficiaryName: yup.string().nullable().optional(),
      beneficiaryAddress: yup.string().nullable().optional(),
      paymentLink: yup.string().nullable().optional(),
    })
    .required(),
  items: yup
    .array()
    .of(
      yup
        .object({
          [K1893InvoiceLineItemKeys.itemNumber]: yup.number().nullable().optional(),
          [K1893InvoiceLineItemKeys.description]: yup.string().nullable().optional(),
          [K1893InvoiceLineItemKeys.externalItemNumber]: yup.string().nullable().optional(),
          [K1893InvoiceLineItemKeys.eaUPC]: yup.string().nullable().optional(),
          [K1893InvoiceLineItemKeys.caseQtyOrdered]: yup.string().nullable().optional(),
          [K1893InvoiceLineItemKeys.caseCost]: yup.string().nullable().optional(),
          [K1893InvoiceLineItemKeys.discountRate]: yup.string().nullable().optional(),
          [K1893InvoiceLineItemKeys.discountPrice]: yup.string().nullable().optional(),
          [K1893InvoiceLineItemKeys.lineTotal]: yup.string().nullable().optional(),
        })
        .required(),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
})

export type K1893InvoiceFileData = yup.InferType<typeof k1893InvoiceFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<K1893InvoiceFileData>

export const k1893InvoiceFileMappings: RequiredFileData = {
  issuer: {
    companyName: '8d4b6ff3-67d3-4826-af21-6743529c397c',
    addressLine1: '9f9b0774-ef10-4239-b075-f99e89462532',
    phoneNumber: '019ae6fb-ec7a-4592-a05c-78d5074b5db2',
    emailAddress: '3c2cde77-c5af-47fe-80b9-c9950ad1ee78',
  },
  recipient: {
    companyName: '6b6374da-4807-4461-8882-db98a4f94a47',
    addressLine1: '5481c123-24b8-4d54-85d2-4fc10b34891f',
    phoneNumber: 'afb5a043-f2e7-4028-ab97-7a716039a9c2',
    emailAddress: 'ea8583d3-ca06-442f-98bb-0c4745d2956d',
  },
  invoiceNumber: '47f3a6aa-4cd9-4e80-95f2-91c3d53e31f9',
  associatedReferenceNumber: 'd62484ff-b149-42c7-b707-9a5f54d4ba02',
  dateIssued: 'e1d2f40e-34c6-4c77-923d-4a19f05b590c',
  dateDue: '0f806dbf-67b3-46f7-9a57-a2d17a5f8de9',
  paymentTerms: '75bad640-8db0-48e0-9c6b-f17da3aa9ada',
  freightTerms: '0954a7d3-8a23-463d-b985-4bfe7517c702',
  remittanceInstructions: {
    routingNumber: '708e0ad8-4e24-4c76-a0a4-bc4d80571bb2',
    accountNumber: '1348d15f-56f9-41e6-9bea-742cb020cf9a',
    bankName: '5f873863-9129-4162-a971-f2eab343cf9f',
    bankAddress: '276963d8-43de-4fd3-87fd-3d6793d4e213',
    beneficiaryName: 'de34b721-7eb1-4667-a947-d13659df0662',
    beneficiaryAddress: 'b4dc4f4b-6ae7-4132-b21d-ca2b8bfc6760',
    paymentLink: 'e3e1f3d9-2a6f-4c5f-8b6b-5f9a4b2f9e1f',
  },
  items: [
    {
      itemNumber: null,
      description: '4797fdf5-69e3-404d-903b-372e252c2521',
      externalItemNumber: '713677cc-aee1-44f5-b4c6-57a4f23da813',
      eaUPC: 'ae3e90d0-4efa-49be-bb57-b230960f2060',
      caseQtyOrdered: '87e2d404-d57c-4b5b-8f06-92520793aade',
      caseCost: '5f101c23-685f-4373-a52a-c47bc58eaf62',
      discountRate: 'f0a4b8f5-9c3b-4d7e-b0f2-5d1a1c6f7e2e',
      discountPrice: null,
      lineTotal: null,
    },
  ],
  agreement: '2b952875-8f7f-46ca-ac9c-98e40c04e105',
  comments: 'ec79a583-a63d-44a7-a1c0-5cc4fb785f4b',
}
